import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index'
import Renderer from './renderers/renderer'
import Mutator from './renderers/mutator'
import * as Actions from './actions/actions'

export default class ResizeWindow {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
        this._renderer = new Renderer(this._settings);
        this._mutator = new Mutator(this._settings);

        try {
            this._$ = require('jquery').noConflict(true);
        } catch (e) {
			console.error(`ResizeWindow error: ${e}`);
        }
    }

    static getDefaultSettings() {
    	return settings;
	}

    getReducer() {
        return reducer;
    }

    getRenderer() {
        return this._renderer.getRender();
    }

    getMutator() {
        return this._mutator.getMutate();
    }

    initialize(store) {
        this._store = store;

        this._renderer.initialize(store);
        this._mutator.initialize(store);

        // don't add resize listener if auto shrink is disabled
        if (this._settings.Resize.autoFitToViewPort === false) return;

        // automatically shrink to viewport size
        this._$(window).on('resize', (e) => {
            if (!e || e.target !== window)
                return;

            this.resizeInViewport();
        });
    }

    resizeInViewport() {
    	let windowClassName = '.' + this._settings.classNames.windowClassName;

    	let $agentWindow = this._$(windowClassName);
    	if ($agentWindow && $agentWindow.length) {
    		let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    		let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

    		let agentHeight = parseInt($agentWindow.css('height'), 10);
    		let agentWidth = parseInt($agentWindow.css('width'), 10);

    		let agentMinHeight = this._settings.Resize.minHeight;
    		let agentMinWidth = this._settings.Resize.minWidth;
					
    		// set current position
    		let newHeight = agentHeight,
				newWidth = agentWidth;

    		// check if window is smaller than the agent
    		if (windowHeight <= agentHeight)
    			newHeight = windowHeight;
    		if (windowWidth <= agentWidth)
    			newWidth = windowWidth;

			// check if window is smaller that agent minimums
    		if (windowHeight < agentMinHeight)
    			newHeight = agentMinHeight;
    		if (windowWidth < agentMinWidth)
    			newWidth = agentMinWidth;

    		// reposition the agent if needed
    		if (newHeight !== agentHeight || newWidth !== agentWidth) {
				let animating = !!this._$(':animated').has($agentWindow[0]).length;
				let target = animating ? $agentWindow : $agentWindow.stop();
				target.animate({ height: newHeight, width: newWidth }, 'slow', 'linear', () => {
    				let sizeStateLoc = this._settings.stateLocations.Window.size;

    				let newSize = {
    					height: `${newHeight}px`,
    					width: `${newWidth}px`
    				};

    				this._store.dispatch(Actions.setWindowSize(newSize, sizeStateLoc));
    			});
    		}
    	}
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-jquery-resize/src/window-jquery-resize.js